import type { Allocation } from '@moment/horizon-data-access/proposal'

/**
 * Cash (trade consideration) of an allocation. Mirrors the BE's
 * propstats.AllocationNetMoney: net_money is absent only on proposals created
 * before the field existed, where market_value carries the same cash value.
 */
export function allocationNetMoney(
  allocation: Pick<Allocation, 'market_value'> & {
    net_money?: Allocation['net_money'] | null
  },
): number {
  return allocation.net_money ?? allocation.market_value
}
